<template>
    <div class="w-full flex p-4 space-x-2">
        <UIAvatar
            v-if="avatar"
            :avatar="avatar"
            class="shrink-0"
        />
        <div
            v-if="avatarName || time"
            class="space-y-0.5"
        >
            <div
                v-if="avatarName"
                class="content-xs-ux-medium"
            >
                {{ avatarName }}
            </div>
            <div
                v-if="time"
                class="content-xs-ux-regular"
            >
                {{ time }}
            </div>
        </div>
    </div>
</template>

<script setup>
    import UIAvatar from '@/components/ui/UIAvatar.vue'

    const props = defineProps({
        config: Object,
    })

    const avatar = computed(() => {
        return props.config?.data?.avatar
    })

    const avatarName = computed(() => {
        return avatar.value?.description
    })

    const time = computed(() => {
        return props.config?.data?.time
    })
</script>
